import { defineComponent as _defineComponent } from 'vue'
import { computed, useRoute } from '@nuxtjs/composition-api'
import { useRestaurantModel } from '@entities/restaurant'
import { WiFiButton, useWiFiModel } from '@entities/wifi'
import { TranslatorSelect } from '@entities/translator/ui/translatorSelect'
import { useOrderModel } from '@entities/order'
import { isMenuQrTable } from '@entities/restaurant/utils/menuTableRules'


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  emits: ['onClick', 'googleTranslate'],
  setup(__props, { emit: emits }) {

const restaurantModel = useRestaurantModel()
const route = useRoute()



const wifiModel = useWiFiModel()
const orderModel = useOrderModel()

const isMenuQrTableActive = computed(() => {
  const tableId = orderModel.orderData?.tableCode || restaurantModel.tableCode || route.value.params.id
  return isMenuQrTable(restaurantModel.code, tableId)
})

const isTableCodeVisible = computed(() => {
  const tableCode = orderModel.orderData?.tableCode
  if (tableCode == null || String(tableCode) === '0') {
    return false
  }
  if (isMenuQrTable(restaurantModel.code, tableCode)) {
    return false
  }
  return true
})

const headerTitle = computed(() => {
  if (isMenuQrTableActive.value && !isTableCodeVisible.value) {
    return 'Меню'
  }
  return 'Мой счет'
})

const googleTranslate = (lan: string) => {
  emits('googleTranslate', lan)
}

return { __sfc: true,restaurantModel, route, emits, wifiModel, orderModel, isMenuQrTableActive, isTableCodeVisible, headerTitle, googleTranslate, WiFiButton, TranslatorSelect }
}

})